import React from 'react';
import './About.css'
import Fade from 'react-reveal/Fade';
import admin from '../../../images/admin.jpeg'
const About = () => {
    return (
        <section id="about" className="section-container">
            <div className="section-header">
            <h2>About Me</h2>
            </div>
            <div className="article-container">
                <Fade left>
                <article>
                <p>
                    Hello!
                    My name is <span style={{color:"#64ffda"}}>Nabil Woalid Rafiu</span> I'm a professional Front End Developer mainly working with React Js. I'm also familiar with problem solving with Javascript.  
                </p>
                <p>
                    I am comfortable with React.js, Javascript, HTML, CSS, Bootstrap, Firebase, Node.js, MongoDB
                </p>

                <p>
                    Here are a few technologies that I am working with recently:
                     
                </p>
                
                <div className="skill-section">
                    <h3 ><i className="fab fa-html5" style={{color:"#e34c26"}}></i> HTML5</h3>
                    <h3 ><i className="fab fa-css3" style={{color:"#264de4"}}></i> CSS3</h3>
                    <h3 ><i className="fab fa-bootstrap" style={{color:"#563d7c"}}></i> Bootstrap</h3>
                    <h3><i className="fab fa-js" style={{color:" #f0db4f "}}></i> JavaScript (ES6)</h3>
                    <h3><i className="fab fa-react" style={{color:"#61DBFB"}}></i> React Js</h3>
                    <h3><i className="fab fa-node" style={{color:"green"}}></i> Node Js</h3>
                    <h3><i className="fas fa-file-excel" style={{color:"yellow"}}></i> Express js</h3>
                    <h3><i className="fab fa-envira" style={{color:"green"}}></i> MongoDB</h3>
                    
                </div>
                </article>
            </Fade>
                <Fade top>
                <div className="about-img">
                    {/* <img src={admin} alt=""/> */}
                </div>
                </Fade>
            </div>
        </section>
    );
};

export default About;